/*

  GataDagsins-Board-Rack.ts

  Board and rack component for Gáta Dagsins

  Copyright (C) 2025 Miðeind ehf.
  Author: Vilhjálmur Þorsteinsson

  The Creative Commons Attribution-NonCommercial 4.0
  International Public License (CC-BY-NC 4.0) applies to this software.
  For further information, see https://github.com/mideind/Netskrafl

*/

import { Component, m } from "./mithril";
import { IPlayerMove, IView } from "./types";
import { Board } from "./board";
import { RackTiles } from "./rack";
import { ButtonsRecallScramble } from "./buttons";
import { RiddleScore } from "./riddlescore";

interface IAttributes {
  view: IView;
}

export const GataDagsinsBoardAndRack: Component<IAttributes> = {
  // Component containing the board (top) and rack (bottom)
  view: (vnode) => {
    const { view } = vnode.attrs;
    const { riddle } = view.model;
    if (!riddle) {
      // If no riddle is available, return an empty div
      return m(".gatadagsins-board-rack-wrapper", "");
    }
    // Is the move currently on the board valid, and the best possible move?
    const celebrate = riddle.wordGood && (riddle.currentScore || 0) >= riddle.bestPossibleScore;

    return m(".gatadagsins-board-rack-wrapper",
      [
        // Board area (top)
        m(".gatadagsins-board-area" + (celebrate ? ".celebrate" : ""),
          [
            riddle ? m(Board, { view, game: riddle, review: false }) : "",
          ],
        ),
        // Rack area (bottom)
        m(".gatadagsins-rack-area",
          [
            m(".rack-left", m(ButtonsRecallScramble, { view, game: riddle })),
            m(".rack", m(RackTiles, { view, game: riddle, review: false })),
            m(RiddleScore, { riddle }),
          ]
        )
      ]
    );
  }
};
